import { useCallback } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SupplementalDataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/supplemental-data-set-config';
import { SupplementalDataSetResumeGradingRubricV2 } from 'libs/end-to-end/src/types/databases/data-sets/supplemental-data-set-config';
import { AllowedOpenAiModels } from 'libs/end-to-end/src/types/databases/data-sets/data-set-resume-rubric';
import { SupplementalDatasetType } from 'libs/end-to-end/src/datasets';

export interface DataSetEditSupplementalHook {
  config: SupplementalDataSetConfig;
  setConfig: Setter<SupplementalDataSetConfig>;
}

export const useDataSetEditSupplemental = (): DataSetEditSupplementalHook => {
  const [supplementalDataSetType, setSupplementalDataSetType] =
    useState<SupplementalDatasetType>('external_pay_benchmarking');

  const [openAiModel, setOpenAiModel] =
    useState<AllowedOpenAiModels>('gpt-4o-mini');

  const [rubricsByJobTitle, setRubricsByJobTitle] = useState<
    SupplementalDataSetResumeGradingRubricV2[] | null
  >(null);

  const [enableCompositeResumeScoring, setEnableCompositeResumeScoring] =
    useState(false);

  const [useV2Grading, setUseV2Grading] = useState(false);

  const setConfig = useCallback((config: SupplementalDataSetConfig) => {
    setSupplementalDataSetType(config.supplementalDataSetType);

    if (config.supplementalDataSetType === 'resumes') {
      setOpenAiModel(config.openAiModel);
      setRubricsByJobTitle(config.rubricsByJobTitle ?? []);
      setEnableCompositeResumeScoring(config.enableCompositeResumeScoring);
      setUseV2Grading(config.useV2Grading);
    }
  }, []);

  return useMemo(() => {
    const baseConfig = {
      dataSetType: 'Supplemental' as const,
      supplementalDataSetType,
    };

    if (supplementalDataSetType === 'resumes') {
      return {
        config: {
          ...baseConfig,
          supplementalDataSetType: 'resumes' as const,
          openAiModel,
          enableCompositeResumeScoring,
          useV2Grading,
          rubricsByJobTitle,
        },
        setConfig,
      };
    } else {
      return {
        config: {
          ...baseConfig,
          supplementalDataSetType: supplementalDataSetType as
            | 'external_pay_benchmarking'
            | 'internal_pay_benchmarking',
        },
        setConfig,
      };
    }
  }, [
    supplementalDataSetType,
    openAiModel,
    rubricsByJobTitle,
    enableCompositeResumeScoring,
    useV2Grading,
    setConfig,
  ]);
};
